import { twMerge } from 'tailwind-merge';

import CheckedIcon from 'assets/events/icons/checked-icon.svg';

type FilterCheckboxProps = {
  title: string;
  checked: boolean;
  onChange: ((checked: boolean) => void) | (() => void);
  isSingleSelection?: boolean;
  className?: string;
};

export const FilterCheckbox = ({
  title,
  checked,
  onChange,
  isSingleSelection = false,
  className,
}: FilterCheckboxProps) => {
  const handleClick = () => {
    if (isSingleSelection) {
      (onChange as () => void)();
    } else {
      (onChange as (checked: boolean) => void)(!checked);
    }
  };

  return (
    <button
      type="button"
      className={twMerge(
        'tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-border-none tw-bg-transparent tw-outline-none',
        className
      )}
      onClick={handleClick}
    >
      <span className="tw-font-regular tw-mx-[20px] tw-font-jost tw-text-[16px] tw-uppercase tw-leading-[25px] tw-text-white">
        {title}
      </span>
      <div className="tw-flex tw-h-[40px] tw-w-[40px] tw-items-center tw-justify-center tw-rounded-[10px] tw-bg-[#4E4E4E]">
        {checked && <img src={CheckedIcon} alt="Checked" className="tw-h-[20px] tw-w-[24px]" />}
      </div>
    </button>
  );
};
